import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {getSelectedValue, setSelectedValue} from "../../Utils";

export class PqmFieldDate extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "bool:*" ];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent({
			'chbox': '<input type="checkbox" mu="value#value" />',
			'yesNo': `<span class="rbl-horizontal-item">
				<label><input type="radio" mu-name="value" mu-change="value_change" mu-id="value_true" value="true">Ano</label>
				<label><input type="radio" mu-name="value" mu-change="value_change" mu-id="value_false" value="false">Ne</label>
				</span>`,
		}[this.control]);
	}

	getValue(): any {
		return (this.control === "chbox")
			? this.ui.value.checked
			: JSON.parse(getSelectedValue(this.ui.value_true) || "null");
	}

	setValue(value: any) {
		if (this.control === "chbox")
			this.ui.value.checked = value;
		else
			setSelectedValue(this.ui.value_true, JSON.stringify(value));
	}

	isFilled(): boolean {
		return (this.control === "chbox")
			? super.isFilled()
			: this.getValue() !== null;
	}

	setDisabled(disabled: boolean) {
		for (const k of ['value_true', 'value_false', 'value']) {
			if (this.ui[k])
				this.ui[k].disabled = disabled;
		}
	}
}

PqmFieldRegister.register(PqmFieldDate);